import { useEffect, useMemo } from 'react';
import Layout from 'components/widgets/Dashboard/Layout';
import CollectionDetails from 'components/widgets/Dashboard/SharedProjects/CollectionDetails';
import CollectionList from 'components/widgets/Dashboard/SharedProjects/CollectionList';
import { useAnalytics } from 'hooks/useAnalytics';
import { useCollectionsShared } from 'hooks/useCollections';
import { useSelectedSharedCollectionQuery } from 'state/queryParams';
import {
  SharedProjectsPageViewSections,
  SharedProjectsPageViewSubSections,
} from 'utils/analytics/constants';

const SharedProjects = () => {
  const { result: sharedList, loading: sharedProjectsLoading } = useCollectionsShared();
  const { usePageViewTracking } = useAnalytics();
  const [selectedGroup, setSelectedGroup] = useSelectedSharedCollectionQuery();
  const filteredSharedList = useMemo(() => sharedList?.data, [sharedList]);

  usePageViewTracking({
    sectionName: SharedProjectsPageViewSections.SHARED_PROJECTS,
    subSectionName: SharedProjectsPageViewSubSections.HOME,
  });

  // Auto-select first shared collection if collections exist and none is selected
  useEffect(() => {
    if (filteredSharedList && filteredSharedList.length > 0 && !selectedGroup) {
      setSelectedGroup(String(filteredSharedList[0].id));
    }
  }, [filteredSharedList, selectedGroup, setSelectedGroup]);

  return (
    <Layout
      menuContent={
        <CollectionList
          groups={filteredSharedList || []}
          loading={sharedProjectsLoading}
        />
      }
      detailContent={<CollectionDetails />}
    />
  );
};

export default SharedProjects;
